export enum FloorplanFrontDirection {
  Bottom = 'bottom',
  Left = 'left',
}
